import { Layout, MyMap } from "components"
export const Map = () => {
 return (
  <Layout>
   <MyMap height={`85vh`} />
  </Layout>
 )
}
